/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RefType } from './RefType';
import {
    RefTypeFromJSON,
    RefTypeFromJSONTyped,
    RefTypeToJSON,
} from './RefType';

/**
 * 
 * @export
 * @interface FileRefInputSchema
 */
export interface FileRefInputSchema {
    /**
     * 
     * @type {string}
     * @memberof FileRefInputSchema
     */
    uri: string;
    /**
     * 
     * @type {RefType}
     * @memberof FileRefInputSchema
     */
    refType?: RefType;
    /**
     * 
     * @type {string}
     * @memberof FileRefInputSchema
     */
    relativePath?: string;
}

/**
 * Check if a given object implements the FileRefInputSchema interface.
 */
export function instanceOfFileRefInputSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "uri" in value;

    return isInstance;
}

export function FileRefInputSchemaFromJSON(json: any): FileRefInputSchema {
    return FileRefInputSchemaFromJSONTyped(json, false);
}

export function FileRefInputSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileRefInputSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uri': json['uri'],
        'refType': !exists(json, 'ref_type') ? undefined : RefTypeFromJSON(json['ref_type']),
        'relativePath': !exists(json, 'relative_path') ? undefined : json['relative_path'],
    };
}

export function FileRefInputSchemaToJSON(value?: FileRefInputSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uri': value.uri,
        'ref_type': RefTypeToJSON(value.refType),
        'relative_path': value.relativePath,
    };
}

